import Vue from "vue";

Vue.prototype.$stripe = window?.Stripe(
  process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
);
